module.exports = __webpack_public_path__ + "static/media/contrato_registrado_ante_profeco.cd42ca7b.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/contrato_registrado_ante_profeco.pdf
// module id = 316
// module chunks = 0